import React from 'react';

function StatCard({ icon, label, value, subtitle, subtitleClassName }) {
  return (
    <div className="rounded-xl bg-white border border-gray-200 shadow-sm p-4 flex flex-col gap-2">
      <div className="flex items-center gap-2 text-gray-500">
        {icon}
        <span className="text-xs font-medium uppercase tracking-wide">{label}</span>
      </div>
      <span className="text-2xl font-semibold text-gray-900">{value}</span>
      {subtitle && (
        <span className={`text-xs ${subtitleClassName ?? 'text-gray-400'}`}>{subtitle}</span>
      )}
    </div>
  );
}

export default StatCard;